import "./LeafTabViewHeader.scss";

type TabViewHeaderItem = {
  id?: string;
  title?: string;
  activeView: string;
  disabled?: boolean;
};

type Props = {
  tabItem: TabViewHeaderItem;
  tabHeaderOnClick: Function;
  buttonify?: boolean;
};

const LeafTabViewHeader = (props: Props) => {
  const { tabItem, tabHeaderOnClick, buttonify } = props;
  const { id, title, activeView, disabled } = tabItem;

  const onClickTabHeader = () => {
    if (!disabled) {
      tabHeaderOnClick(id);
    }
  };

  const onKeyPressTabHeader = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      if (!disabled) {
        tabHeaderOnClick(id);
      }
    }
  };

  return (
    <div className={buttonify ? "leafTabHeaderContainer" : ""}>
      <div
        role="tab"
        id={id}
        data-testid={id ? `performance-tab-${id}` : undefined}
        aria-selected={id === activeView ? "true" : "false"}
        tabIndex={disabled || id !== activeView ? -1 : 0}
        aria-controls={`tabpanel-${id}`}
        onClick={onClickTabHeader}
        onKeyDown={onKeyPressTabHeader}
        className={
          !buttonify
            ? `leaf-tab-view-header-item leaf-tab-view-header-item__nav-item${
                id === activeView ? "--active leaf-tab-view-header-item__nav-item" : ""
              }${disabled ? "--disabled leaf-tab-view-header-item__nav-item" : ""}`
            : `buttonify ${id === activeView ? "active" : ""}`
        }
      >
        {title}
      </div>
    </div>
  );
};

export default LeafTabViewHeader;
